import React from "react";

interface DonutDataItem {
  name: string;
  value: number;
  color: string;
}

interface Props {
  data: DonutDataItem[];
  title: string;
}

const GenericDonutChart: React.FC<Props> = ({ data, title }) => {
  const total = data.reduce((sum, item) => sum + item.value, 0);
  const circumference = 2 * Math.PI * 70; 

  let cumulativeOffset = 0;

  return (
    <div className="chart-card">
      <h3>{title}</h3>
      <div className="donut-chart">
        <svg viewBox="0 0 200 200" className="donut-svg">
          {data.map((item, index) => {
            const dashArray = (item.value / total) * circumference;
            const offset = -cumulativeOffset;
            cumulativeOffset += dashArray;
            
            return (
              <circle
                key={index}
                cx="100"
                cy="100"
                r="70"
                fill="none"
                stroke={item.color}
                strokeWidth="40"
                strokeDasharray={`${dashArray} ${circumference}`}
                strokeDashoffset={offset}
                transform="rotate(-90 100 100)"
              />
            );
          })}
        </svg>
      </div>
      <div className="legend">
        {data.map((item, index) => (
          <div key={index} className="legend-item">
            <span
              className="legend-dot"
              style={{ background: item.color }}
            ></span>
            <span>{item.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GenericDonutChart;